import { render, staticRenderFns } from "./TrainModel.vue?vue&type=template&id=00955a54&scoped=true"
import script from "./TrainModel.vue?vue&type=script&lang=js"
export * from "./TrainModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00955a54",
  null
  
)

export default component.exports